import React, { useState } from "react";
import { ReactComponent as MenuIcon } from "../../Assets/Icons/menu-alt-2.svg";
import { ReactComponent as SearchIcon } from "../../Assets/Icons/search.svg";
import { ReactComponent as AnnotationIcon } from "../../Assets/Icons/annotation.svg";
import { ReactComponent as BellIcon } from "../../Assets/Icons/bell.svg";
import Avatar from "../../Assets/Avatar.png";
import NotificationComponent from "../NotificationComponent";
import AvatarComponent from "../AvatarComponent";
import NotificationSettingModal from "../NotificationSettingModal";

const Header = () => {
  const [openNotifications, setOpenNotifications] = useState(false);
  const [profileDropDown, setProfileDropDown] = useState(false);
  const [handleSettingsModal, setHandleSettingsModal] = useState(false);

  return (
    <header className="flex flex-row items-center justify-between px-4 py-2 border-b-2 w-full">
      <div className="flex items-center gap-5">
        <MenuIcon />
        <div className="rounded-lg border flex items-center py-2 px-3 bg-[#F9FAFB] w-[23rem]">
          <SearchIcon />
          <input
            type="text"
            placeholder="Search"
            className="border-none ml-2 bg-inherit w-full text-sm font-medium text-[#6B7280] focus:outline-none"
          />
        </div>
      </div>
      <div className="flex items-center gap-x-4">
        <div className="relative">
          <button onClick={() => setOpenNotifications(!openNotifications)}>
            <BellIcon />
          </button>
          {openNotifications && (
            <div
              className="absolute right-0 top-4 mt-2 bg-white z-50"
              onBlur={() => setOpenNotifications(false)}
            >
              <NotificationComponent
                handleSettingsModal={setHandleSettingsModal}
                handleModal={() => setOpenNotifications(false)}
              />
            </div>
          )}
        </div>
        <div className="relative">
          <button
            onClick={() => setProfileDropDown(!openNotifications)}
            onBlur={() => setProfileDropDown(false)}
          >
            <div
              style={{
                backgroundImage: `url(${Avatar})`,
                backgroundPosition: "center",
                backgroundSize: "cover",
              }}
              className="rounded-full w-10 h-10"
            />
          </button>
          {profileDropDown && (
            <div className="absolute right-0 top-10 mt-2 bg-white z-50">
              <AvatarComponent />
            </div>
          )}
        </div>
      </div>
      {handleSettingsModal && (
        <NotificationSettingModal
          open={handleSettingsModal}
          setOpen={setHandleSettingsModal}
        />
      )}
    </header>
  );
};

export default Header;
